/**
 * IP_Util.js
 *
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.02.21
 * @작성 : SuperMoon
 * @참조 :
 */

import { isDist } from 'interpreter/dev/util/IP_Config';

const IP_Util = (function(){

	return class  {

		// @DES :: dist 상태값에 따라 print 처리하는 함수
		static print(str) { if(!isDist()) console.log(str); }

		// @DES :: dist 상태값에 따라 alert 처리하는 함수
		static alert(str) { if(!isDist()) alert(str); }

		// @DES :: json을 clone 하는 함수
		static clone(json) { return JSON.parse(JSON.stringify(json)); }

		/**
		 * @DES :: Protected 객체 던지기
		 * @IP1 :: obj {obj}
		 * @O.P :: str {str}
		 * @S.E ::
		 */
		static getProtected(obj) {
			// console.log('================================================', obj._id);
			try {
				let scope = obj;    	      // [#] 스코프 저장소
				let result = function () {};  // [#] protected 객체

				// [#] Object down to top ( child -> parent -> object )
				for (let o = scope; o != Object.prototype; o = Object.getPrototypeOf(o)) {
					for (let name of Object.getOwnPropertyNames(o)) {
						if (name == 'constructor') continue; // [#] 생성자 제외
						if (name[0] == '_') continue;        // [#] '_' protected 제외
						if (!result.prototype[name]) setProperty(scope, o, result, name);
					}

					function setProperty(scope, o, result, name) {
						let preDescriptor = Object.getOwnPropertyDescriptor(o, name);
						let newDescriptor = {};
						if (preDescriptor.get || preDescriptor.set) {
							// [#] CASE01 - used getter & setter
							if (preDescriptor.get) result.prototype.__defineGetter__(name, function () {
								return scope[name]
							});
							if (preDescriptor.set) result.prototype.__defineSetter__(name, function (arg) {
								return scope[name] = arg
							});
							return;
						}
						else {
							// [#] CASE02 - property & prototype (분기처리)

							// [*] number & string - 객체 참조 (get & set 이용)
							if (
								(typeof scope[name] !== 'object' && typeof scope[name] !== 'function')
								||
								scope[name] === null
							) {
								result.prototype.__defineGetter__(name, function () {
									return scope[name]
								});
								result.prototype.__defineSetter__(name, function (arg) {
									return scope[name] = arg
								});
								return;
							}

							// [*] Function - scope 유지
							if (scope[name] instanceof Function) {
								result.prototype[name] = function (...arg) {
									return scope[name](...arg)
								};
								return;
							}

							// [*] Object - 객체 참조
							else {
								result.prototype[name] = scope[name];
								return;
							}
						}
					}
				}
				return new result();
			} catch (e) {
				B_Util.print('[코드모스] => getProtected in B_Util - ' + e);
			}
		}

	}
}());

export default IP_Util;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/interpreter/dev/util/IP_Util.js